import React, { FC } from 'react';

export const HamiBalanceSlideBackgroundOverlay: FC = ({}) => {
  return (
    <>
      <div className="absolute left-0 top-0 z-0 h-full w-full bg-[url('https://s3.ir-thr-at1.arvanstorage.com/mofidapp/common/noise.webp')] opacity-30" />
      <div className="absolute left-0 top-0 z-0 h-full w-full bg-[url('https://s3.ir-thr-at1.arvanstorage.com/mofidapp/common/pattern.png')] bg-[left_bottom] bg-repeat-x" />
    </>
  );
};
